function CertificateHeader(props) {
  const name = props.name;
  return (
    <div className="">
      <div className="certficateHeader ">
        <div className="certficateHeader-info">
          <h2>{name}</h2>
        </div>
      </div>
    </div>
  );
}

export default CertificateHeader;
